import React from 'react';
import PropTypes from 'prop-types';

import styles from './Pricing.m.sass';

import cx from 'classnames';

import ChannelPrice from '../../containers/channelUtils/ChannelPrice';

export default function Pricing({value, originalValue, channel, annotation, small, accent}) {
  return (
    <span className={cx(
      styles.pricing,
      {[styles.pricing__small]: small},
      {[styles.pricing__accent]: accent}
    )}>
      <span className={styles.pricing_value}>
        {annotation}
        {annotation && ' '}
        <ChannelPrice
          price={value}
          channel={channel}
        />
      </span>
      {originalValue && (
        <ChannelPrice
          className={styles.pricing_originalValue}
          price={originalValue}
          channel={channel}
        />
      )}
    </span>
  );
}

Pricing.propTypes = {
  value: PropTypes.number.isRequired,
  originalValue: PropTypes.number,
  channel: PropTypes.string,
  annotation: PropTypes.node,
  accented: PropTypes.bool
};



// WEBPACK FOOTER //
// ./components/pricing/Pricing.js